import styled from 'styled-components/macro';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Code = styled.div`
  width: 55px;
  height: 71px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid rgba(17,32,43,0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CodeInput = styled.input`
  width: 40px;
  height: 60px;
  font-size: 30px;
  font-family: Squad-Bold, Squad;
  font-weight: bold; color: #11202B;
  border: unset;
  text-align: center;
  padding: 0!important;
`;